import React from 'react';
import { Typography } from '@mui/material';
import Banner from '../assets/images/Banner.png'

const HeroBanner = () => {
  return (

    <>
      <div className='container'>
        <div class="row flex-lg-row-reverse align-items-center g-5 ">
          <div class="col-10 col-sm-8 col-lg-6">
            <img src={Banner} alt='Banner' className="hero-banner-img " />
          </div>
          <div class="col-lg-6" style={{ 'padding-top': '20vh' }}>
            <h3 class="display-5 fw-bold text-body-emphasis lh-1 mb-4" style={{ 'font-size': '5vh', 'text-transform': 'uppercase', 'font-family': ' sans-serif' }}>Fitness Zone</h3>
            <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-5" style={{ 'font-size': '8.5vh', 'text-transform': 'uppercase', 'font-family': ' Helvetica' }}>Step Up Your <br /><span style={{ color: '#1d4ed8' }}>Fitness Chalange</span><br /> With US</h1>
            <div class="d-grid gap-2 d-md-flex justify-content-md-start">
              <a type="button" class="btn btn-hero" href="#exercises">Explore Exercise</a>
            </div>

            <Typography fontWeight={600} color="#3b82f6" mt={'10vh'} sx={{ opacity: '0.1', display: { lg: 'block', xs: 'none' }, fontSize: '200px' }}>
              Exercise
            </Typography>
          </div>
        </div>
      </div>

    </>
  )
}

export default HeroBanner